import React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LeftIcon from "@mui/icons-material/ChevronLeft";
import RightIcon from "@mui/icons-material/ChevronRight";
//Limitless imports
import { formatSuggesterAnswerConfidence } from "../../../../..";
const SAFullScreenDialog = ({
  t,
  classes,
  mainClasses,
  open,
  title,
  currentAnswer,
  value,
  totalSuggestedAnswer,
  onChangeIndex,
  renderAnswers,
  leftArrowClick,
  rightArrowClick,
  onClose,
  renderPersonaliseButtons,
  moreThanOneSA
}) => {
  const allClasses = {
    ...classes,
    ...mainClasses
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    keepMounted: true,
    onClose: onClose,
    maxWidth: "md",
    classes: {
      paper: classes.dialog
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    className: classes.title
  }, title), /*#__PURE__*/React.createElement(DialogContent, {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: allClasses.outerBody
  }, /*#__PURE__*/React.createElement("div", {
    className: allClasses.arrowArea
  }, moreThanOneSA && /*#__PURE__*/React.createElement(LeftIcon, {
    onClick: leftArrowClick,
    className: value === 0 ? allClasses.arrowDisableIcon : allClasses.arrowIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: allClasses.saBodyArea
  }, /*#__PURE__*/React.createElement(SwipeableViews, {
    index: value,
    onChangeIndex: onChangeIndex,
    containerStyle: {
      height: "100%"
    }
    //slideStyle={fullScreen ? {} : { overflow: "hidden" }}
  }, renderAnswers({
    responseListItem: classes.responseListItem
  })), currentAnswer.suggestedAnswerScore && /*#__PURE__*/React.createElement("div", {
    className: allClasses.confidenceContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    color: theme => theme.palette.text.primary,
    variant: "caption"
  }, t("{0}% confidence", formatSuggesterAnswerConfidence(currentAnswer.suggestedAnswerScore))))), /*#__PURE__*/React.createElement("div", {
    className: allClasses.arrowArea
  }, moreThanOneSA && /*#__PURE__*/React.createElement(RightIcon, {
    onClick: rightArrowClick,
    className: value === totalSuggestedAnswer - 1 ? allClasses.arrowDisableIcon : allClasses.arrowIcon
  })))), renderPersonaliseButtons(true)));
};
const styles = () => ({
  dialog: {
    maxHeight: "80%",
    padding: 24
  },
  title: {
    textAlign: "center",
    paddingBottom: 0
  },
  content: {
    display: "flex"
  },
  responseListItem: {
    display: "flex",
    flex: 1,
    padding: "10px 5px 0px 5px",
    flexDirection: "column",
    overflowY: "auto",
    overflowX: "hidden",
    marginBottom: 5
  }
});
export default withStyles(styles)(SAFullScreenDialog);
SAFullScreenDialog.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  currentAnswer: PropTypes.object.isRequired,
  value: PropTypes.number.isRequired,
  totalSuggestedAnswer: PropTypes.number.isRequired,
  onChangeIndex: PropTypes.func.isRequired,
  renderAnswers: PropTypes.func.isRequired,
  leftArrowClick: PropTypes.func.isRequired,
  rightArrowClick: PropTypes.func.isRequired,
  renderPersonaliseButtons: PropTypes.func.isRequired,
  mainClasses: PropTypes.object.isRequired,
  moreThanOneSA: PropTypes.bool.isRequired
};